import "//shopakaso.com/cdn/shop/t/4/assets/swiper@11.min.js?v=104684603862494721831712112037"
import "//shopakaso.com/cdn/shop/t/4/assets/alpine-store-product.js?v=106176092735348342261721380726"
import { LiquidData } from "//shopakaso.com/cdn/shop/t/4/assets/goc-shopify-liquid.js?v=68280490349276499341742357734"

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data('productBuyBottom', function () {
    return {
      get product() {
        if (!this.$store.product) {
          return null
        }
        return this.$store.product.data
      },

      get title() {
        if (!this.product) {
          return ""
        }
        return this.product.title
      },

      get variantTitle() {
        if (!this.variant) {
          return ""
        }

        return this.variant.title
      },

      get variantImg() {
        if (!this.variant) {
          return null
        }

        if (!this.variant.featured_image && this.product) {
          if (typeof this.product.featured_image === "string") {
            return this.product.featured_image
          }
          return this.product.featured_image.src
        }

        return this.variant.featured_image.src
      },

      get isSoldOut() {
        if (!this.variant) {
          return true
        }

        return this.variant.available === false
      },

      init() {
        this.variant = LiquidData.selectedVariant()
        console.log(this.variant)
        this.$watch('product', (product) => {
          if (!product) {
            return
          }
          this.updatePrice()
          this.listenVariantChange()
        })
      },

      variant: null,
      price: '',
      originalPrice: '',
      async listenVariantChange() {
        if (!this.variant) {
          // 默认选中第一个
          this.variant = this.product.variants[0]
        }
        console.log('sa')
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event.data.variant) {
            console.log("var not changing here???", event)
            return
          }
          this.variant = event.data.variant
          this.updatePrice()
          let a = document.querySelector('[bss-b2b-order-list-total-line]')
          a.setAttribute('bss-b2b-order-list-total-line',this.variant.id)
          console.log("var changing here???", event)
        })

        subscribe(PUB_SUB_EVENTS.quantityChange, (event) => {
          if (!this.variant && !event.data.variant) {
            return
          }
          this.variant = this.variant ? this.variant : event.data.variant
          this.updatePrice()
        })
      },

      async updatePrice() {
        this.price = await LiquidData.priceByProductId(this.product.id)
        this.originalPrice = await LiquidData.updatePrice()
      },

      // 回到顶部
      backToTop() {
        document.documentElement.scrollTop = 0
      },

      currActiveIndex: '',
      clickAddToCart(secId) {
        console.log();
        this.currActiveIndex = secId;
        
        let toTrigger1 = `ProductSubmitButton-${this.currActiveIndex}__seemor-product`;
        let toTrigger2 = `ProductSubmitButton-${this.currActiveIndex}__main`;

        let buttonToTrigger = document.getElementById(toTrigger1);

        if (!buttonToTrigger) {
          buttonToTrigger = document.getElementById(toTrigger2);
        }

        if (buttonToTrigger) {
          buttonToTrigger.click();
        } else {
          console.error(`Element not found: #${toTrigger1} or #${toTrigger2}`);
        }
      },

      cartAction: throttle(function (e) {
        if (!this.isSoldOut) {
          e.stopPropagation()
          this.handleCart()
        }
      }, 2000),
    }
  })
}

document.addEventListener('alpine:init', main)
